import React, { useEffect, useRef, useState } from 'react';
import iconUpload from '../../images/icon-upload.svg';
import * as securityHelper from "../../helper/SecurityHelper";
import axios from "axios";

export default function NonconformDetail({ detailData, auth, setDetail, setSnackbarTxt }: any) {
  const [fileName, setFileName] = useState('');
  const fileRef = useRef() as React.MutableRefObject<any>;
  const fileBtnRef = useRef<any>();
  const [afFileSrc, setAfFileSrc] = useState<any>();
  const user: any = securityHelper.getLoginUser();
  const fileHandler = () => { fileRef.current.click(); };

  useEffect(() => {
    let imgSrc;
    if (fileRef.current) {
      const afFileList = fileRef.current.files;
      if (afFileList.length > 0) {
        imgSrc = URL.createObjectURL(afFileList[0]);
        setAfFileSrc(imgSrc);
      }
    }
  }, [fileName])

  const fn_onCfrmBtnClick = async () => {
    if ((auth === 'SRV' && detailData.prcsStat !== '003') || (auth === 'COM' && detailData.prcsStat === '001')) {
      const afFileList = fileRef.current.files;
      const formData = new FormData();
      let prcsStat;

      if (afFileList.length === 0) {
        setSnackbarTxt('조치 후 사진을 등록해 주세요.');
        setTimeout(() => fileBtnRef.current.click(), 1000)
        return;
      }
      // 자가점검
      if (detailData.chkGbCd === '001') {
        prcsStat = '002';
        // 코엑스 점검
      } else if (detailData.chkGbCd === '002') {
        prcsStat = '002';
      }
      const jsonObject = {
        prcsStat: prcsStat,
        sftyChkSeq: detailData.sftyChkSeq,
        userSeq: user.seq
      }
      if (afFileList.length > 0) {
        formData.append('afFiles', afFileList[0]);
        formData.append('jsonData', JSON.stringify(jsonObject));
      }
      const rtrnData = await axios.post('admin/api/sftyChk/updateSftyChkData', formData)
      if (rtrnData.data > 0) {
        setSnackbarTxt('저장 되었습니다.');
        setTimeout(() => window.location.reload(), 1000);
      }
    } else {
      setDetail(false);
    }
  }

  return (
    <div className='h-[calc(100%-52px)] md:h-[calc(100%-130px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center'>
      <div className='w-[265px] sm:w-[318px] md:w-[750px]'>
        <p className='mt-32 md:mt-[80px] ml-8 sm:ml-[20px] font-preBold text-15 md:text-37 leading-18 md:leading-[45px]'>상세내용</p>
        {auth !== 'COM'
          ? <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-15 md:mt-[37px]'>
            <tbody>
              <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]'>
                <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 leading-15 md:w-[145px] md:text-32 '>요청사</td>
                <td className='align-middle pl-14 md:pl-[35px] font-preLight w-260 md:w-[650px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{detailData.rgstCmpnyNm}</td>
              </tr>
            </tbody>
          </table> : null
        }
        <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-20 md:mt-[50px]'>
          <tbody>
            <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>장소</td>
              <td className='align-middle pl-14 font-preLight w-260 md:w-[650px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{detailData.exbtPlc} {detailData.bthNo}</td>
            </tr>
            <tr className='h-107 md:h-[267px] text-14 md:text-35 leading-16 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>내용</td>
              <td className='align-top pt-12 pl-14 pr-12 font-preLight w-260 md:w-[650px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{detailData.cntnts}</td>
            </tr>
            <tr className='h-108 md:h-[270px] text-14 md:text-35 leading-16 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>조치 전</td>
              <td className='flex justify-center pt-7 md:pt-[17px] w-260 md:w-[650px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>
                <img src={'admin/api/cmmn/fileDownload?atchFileId=' + detailData.actBfAtchFileId + '&fileSn=0'} alt='nonconformImage' className='object-cover border border-[#D9D9D9]' />
              </td>
            </tr>
            <tr className='h-108 md:h-[270px] text-14 md:text-35 leading-16 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>조치 후</td>
              <td className='flex flex-col justify-center items-center pt-7 md:pt-[17px] w-260 md:w-[650px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>
                {detailData.actAfAtchFileId ?
                  <img src={'admin/api/cmmn/fileDownload?atchFileId=' + detailData.actAfAtchFileId + '&fileSn=0'} alt='nonconformImage' className='object-cover border border-[#D9D9D9]' />
                  : auth === 'KOX' ? <p className='mt-30 md:mt-[75px]'>부적합 조치 전입니다.</p> : !fileName
                    ? <button
                      ref={fileBtnRef}
                      onClick={fileHandler}
                      className='mt-25 md:mt-[62px] flex justify-center items-center w-125 h-38 md:w-[312px] md:h-[95px] outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>
                      <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                      <p>파일 올리기</p>
                    </button>
                    : <><img onClick={fileHandler} src={afFileSrc} alt='doneImage' className='object-cover border border-[#D9D9D9]' />
                      <button
                        ref={fileBtnRef}
                        onClick={fileHandler}
                        className='my-7 md:my-[17px] flex justify-center items-center w-[70%] h-38 md:h-[95px] outline-none border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-gray-400 font-preLight'>
                        <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                        <p>삭제</p>
                      </button></>}
                <input hidden onChange={(e) => setFileName(e.target.value.substring(12))} type='file' ref={fileRef} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button onClick={fn_onCfrmBtnClick}
        className='font-preLight text-15 md:text-37 text-white w-[265px] sm:w-[318px] md:w-[750px] h-43 md:h-[107px] pt-10 pb-10 md:pt-[25px] md:pb-[25px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-30 mb-20 md:mt-[75px] md:mb-[50px]'>
        {(auth === 'SRV' && detailData.prcsStat !== '003') || (auth === 'COM' && detailData.prcsStat === '001') ? '저장' : '확인'}</button>
    </div>
  );
}